/* Native Shopify forms handle cart additions. Enhance variant and plan selection only. */
(() => {
  const syncPlan = (surface) => {
    const plan = surface.querySelector('[data-roam-plan]:checked');
    if (!plan) return;
    const price = surface.querySelector('[data-roam-price]');
    const charge = surface.querySelector('[data-roam-charge]');
    const compare = surface.querySelector('[data-roam-compare]');
    if (price) price.textContent = plan.dataset.price;
    if (charge) charge.hidden = plan.value === '';
    if (compare) compare.hidden = plan.value !== '';
  };
  const setup = (root = document) => {
    root.querySelectorAll('[data-roam-hero]').forEach((hero) => {
      if (hero.dataset.roamReady) return;
      hero.dataset.roamReady = 'true';
      const video = hero.querySelector('[data-roam-video]');
      const toggle = hero.querySelector('[data-roam-motion]');
      if (!video || !toggle) return;
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const syncMotion = () => {
        toggle.textContent = video.paused ? 'Play motion' : 'Pause motion';
        toggle.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
      };
      const startMotion = () => {
        if (preference.matches) { video.pause(); toggle.hidden = true; return; }
        const source = video.querySelector('[data-roam-video-src]');
        if (!source.getAttribute('src')) { source.src = source.dataset.roamVideoSrc; video.load(); }
        video.muted = true;
        video.play().then(() => { toggle.hidden = false; syncMotion(); }).catch(() => { toggle.hidden = true; });
      };
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      });
      video.addEventListener('play', syncMotion);
      video.addEventListener('pause', syncMotion);
      preference.addEventListener('change', startMotion);
      startMotion();
    });
    root.querySelectorAll('[data-roam-product]').forEach((surface) => {
      syncPlan(surface);
      if (surface.dataset.roamReady) return;
      surface.dataset.roamReady = 'true';
      const variant = surface.querySelector('[data-roam-variant]');
      if (variant) {
        const submit = surface.querySelector('[data-roam-variant-submit]');
        if (submit) submit.hidden = true;
        variant.addEventListener('change', () => {
          const destination = new URL(window.location.href);
          destination.searchParams.set('variant', variant.value);
          destination.searchParams.delete('selling_plan');
          window.location.assign(destination.href);
        });
      }
      surface.querySelectorAll('[data-roam-plan]').forEach((plan) => {
        plan.addEventListener('change', () => syncPlan(surface));
      });
    });
  };
  setup();
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-roam-product]').forEach(syncPlan));
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
